import ErrorData from '../services/api/models/error-data';

export class ErrorFormatter {
  private errors: ErrorData = new ErrorData();

  constructor(errors: ErrorData = new ErrorData()) {
    this.errors = errors;
  }

  setErrors(errors) {
    this.errors = errors;
  }

  hasError(field) {
    // console.log(field);
    // console.log(this.errors.errors);
    // console.log(field in this.errors.errors);
    if (this.errors && this.errors.hasOwnProperty('errors')) {
      return field in this.errors.errors;
    }
  }

  getErrors(field) {
    if (this.hasError(field)) {
      return this.errors.errors[field];
    }else {
      return [];
    }
  }
}
